import React from 'react';

import { Loadable } from '../../../components/navigation/Loadable';
import { allowedUserType, USER_TYPES } from '../../../utils/constants';
import { withPrivateRoute } from '../withPrivateRoute';

const { PHARMACIST } = USER_TYPES;

/**
 * @satisfies {ExtendedRouteObject}
 */
export const pharmacyStockRoutes = {
  name: 'Pharmacy Stock',
  path: 'pharmacy-stock',
  type: 'item',
  ...withPrivateRoute(Loadable(React.lazy(() => import('../../../components/PharmacyStockPage/PharmacyStock'))), {
    userCanAccess: ({ userType }) => allowedUserType([PHARMACIST], userType),
  }),
};
